import { Navigate } from "react-router-dom";
import { useAppSelector } from "./Redux/hooks";

const Home = () => {
  const isUserAuthenticated = useAppSelector(
    (state) => state.user.isUserAuthenticated
  );
  const role = useAppSelector((state) => state.user.role);

  if (!isUserAuthenticated) {
    return <Navigate to="/auth/login" />;
  }

  if (role === "participant") {
    return <Navigate to="/participant/questionnaires" />;
  }

  return <Navigate to="/app/studies" />;
};

export default Home;
